import React from 'react';
import { createRoot } from 'react-dom/client';

import NeedsSsoPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const createNeedsSsoScreen = ({ ssoLink }) => {
  const root = createRoot(document.getElementById('needsSsoPanel'));
  if (isSupportedBrowser()) {
    root.render(
      <AuthScreenLayout>
        <NeedsSsoPanel ssoLink={ssoLink} />
      </AuthScreenLayout>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createNeedsSsoScreen = createNeedsSsoScreen;
